import { IMessage } from '../../../api/types';

export const getMessagePlaceholder = (messages: IMessage[]): IMessage | undefined => {
    return messages.find((m) => m.is_placeholder);
};
